import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
    excelMapping,
    ExportToExcel,
    twoDecimalPlaces,
} from "../../utils/utilFuctions";
import { GlobalContext } from "../../Context/GlobalState";
import { offsetArr } from "../../utils/CommonConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import { Modal } from "react-bootstrap";
import { BASE_URL_APISERVICES } from "../../utils/Constants";
import { updateUserDetails } from "../../api/admin/AdminApi";
import {adminAuth} from "../../config"
import cogoToast from "cogo-toast";
import Select from "react-select";
import { MD_API_ENDPOINTS } from "../../utils/MDApiEndpoints";

export const columns = [
    {
        dataField: "id",
        text: "ID",
    },
    {
        dataField: "type",
        text: "Type",
    },
    {
        dataField: "sender_user_code",
        text: "Sender",
    },
    {
        dataField: "sender_user_name",
        text: "Sender Name",
    },
    {
        dataField: "receiver_user_code",
        text: "Receiver",
    },
    {
        dataField: "receiver_user_name",
        text: "Receiver Name",
    },
    {
        dataField: "sales_user_code",
        text: "Sales Person",
    },
    {
        dataField: "rch_before_balance",
        text: "Opening Balance",
    },
    {
        dataField: "amount",
        text: "Amount",
    },
    {
        dataField: "rch_after_balance",
        text: "Closing Balance",
    },
    {
        dataField: "status",
        text: "Status",
    },
    {
        dataField: "indate",
        text: "Date",
    },
];

const MasterBusinessReport = () => {
    const { username, password } = adminAuth;
    const [pageAccess, setPageAccess] = useState({});
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [offset, setOffset] = useState(10);
    const [dataToDisplay, setDataToDisplay] = useState([]);
    const [pages, setPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const { user, setTransactionLoaderState } = useContext(GlobalContext);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [billDetails, setBillDetails] = useState({});
    const [amount, setAmount] = useState("");
    const [approveModalOpen, setApproveModalOpen] = useState(false);
    const [reverseAmountModalOpen, setReverseAmountModalOpen] = useState(false);
    const [details, setDetails] = useState({});

    const dateFormatter = (date) => {
        return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
            }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
    };
    const now = (date = new Date()) => {
        return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
            }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
    };

    const getDistributorUserBusinessReport = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username + ":" + password).toString("base64")
                );

            var raw = JSON.stringify({
                userid: user.ReferId,
                "interval": "1"
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${MD_API_ENDPOINTS.getDistributorUserBusinessReport}`,
                requestOptions
            )
                .then((response) => response.json())
                .then((result) => {
                    if (result.responseCode == "00") {
                        setData(result.data);
                    } else {
                        setData([]);
                    }
                })
                .catch((error) => console.log("error", error));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
        setTotal(filteredData.length);
        const startIdx = 0;
        const endIdx = offset - 1;
        filteredData = filteredData.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        setCurrentPage(1);
    }, [searchText]);

    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        console.log(filteredData);
        const startIdx = (currentPage - 1) * offset;
        const endIdx = currentPage * offset - 1;
        console.log({ startIdx, endIdx });
        filteredData = filteredData.filter((bank, idx) => {
            console.log(idx, idx <= endIdx && idx >= startIdx);
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        console.log({ startIdx, endIdx });
    }, [currentPage]);

    // did mount
    useEffect(() => {
        setPages(Math.floor((data.length + (offset - 1)) / offset));
        const startIdx = 0;
        const endIdx = offset - 1;
        setTotal(data.length);
        console.log(startIdx);
        console.log(data);
        const filteredData = data.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        console.log(filteredData);
        setDataToDisplay(filteredData);
    }, [data, offset]);

    const searchBarStyle = {
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "0px",
        backgroundColor: "#fff",
        width: "15%", // Adjust the width as needed
        height: "20%",
    };
    const inputStyle = {
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
        fontSize: "16px",
        marginLeft: "8px",
        width: "100%",
        fontFamily: "Poppins",
        fontWeight: "400",
    };
    const iconStyle = {
        color: "rgba(0, 0, 0, 0.5)",
    };

    const positionStyle = {
        position: "absolute",
        top: -27,
        left: 0,
        fontFamily: "Poppins",
        color: "rgba(255, 255,255, 1)",
    };
    const positionStyle1 = {
        position: "absolute",
        top: -38,
        left: 0,
        fontFamily: "Poppins",
        color: "rgba(255, 255,255, 1)",
    };

    useEffect(() => {
        getDistributorUserBusinessReport();
    }, []);

    const openInNewTab = (data) => {
        localStorage.setItem(
            "print",
            JSON.stringify({ ...data })
            // shopName: Profileinfo.shopname
        );
        const newWindow = window.open(
            `/pages/print/cmsSlip?id=${data.tid}`,
            "",
            "height=600,width=800'"
        );
        if (newWindow) newWindow.opener = null;
    };

    return (
        <>
            <div className="card m-3">
                <div className="row m-0 p-0 pt-1 align-items-center ">
                    <div className="col-3 m-0 p-0">
                        <div
                            className="m-0 p-0 pl-3 align-top"
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "600",
                                lineHeight: "48px",
                                letterSpacing: "0em",
                                textAlign: "left",
                                padding: "0px",
                                background: "#FFFFFF",
                                color: "#4267B2",
                                fontWeight: "bolder",
                                fontfamily: "Poppins !impotent",
                                fontSize: "28px",
                            }}
                        >
                            Distributor's Business Report
                        </div>
                    </div>
                </div>

                <hr className="m-0 p-0" />

                <div style={{ width: "100%" }}>
                    <div style={{ alignItems: "center" }}>
                        <div style={{ flex: "1" }}></div>
                    </div>
                </div>
                <div className=" scroll-inner admin-fix-width borderless-table ">
                    <table
                        className="my-table transparent-table text-center border-bottom"
                        style={{
                            width: "100%",
                            overflowX: "auto",
                            border: "0px",
                            overflow: "auto",
                        }}
                    >
                        <tr className="borderless-table text-center border-bottom">
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                {"Sr"}
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                ID
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                User
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Shop Name
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                AEPS
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                AEPS Settlement
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                PG
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                PG Settlement
                            </th>

                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                DMT
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                BBPS
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Vendor Payments
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                CMS
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Commission
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Refund
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Charges
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Total Business
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Total Charges
                            </th>
                        </tr>
                        {dataToDisplay.map((e, ind) => (
                            <tr className="border-bottom">
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    {" "}
                                    {ind + 1}
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.id}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.userCode}</div>
                                    <div>{e.userName}</div>
                                    <div>{e.userMobile}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.shopName}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.aeps}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.aeps_settlement}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.pg}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.pg_settlement}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.dmt}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.bbps}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.vendor_payments}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.cms}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.commission}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.refund}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.charges}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.totalBusiness}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.totalCharges}</div>
                                </td>


                            </tr>
                        ))}
                    </table>
                </div>
                <Pagination
                    page={currentPage}
                    limit={pages}
                    callback={(page) => {
                        setCurrentPage(page);
                    }}
                    count={dataToDisplay.length}
                    total={total}
                    callback2={(offsetValue) => {
                        setOffset(offsetValue);
                    }}
                />
            </div>
        </>
    );
};


export const Pagination = ({
    page,
    limit,
    callback,
    total,
    count,
    callback2,
}) => {
    console.table({ page, limit, callback });
    const selectStyleLeftBorder = {
        borderRadius: "0px",
        fontFamily: "Poppins",
        fontsize: "16px",
        borderRight: "1px solid rgba(0, 0, 0, 0.2)", // Remove the border
        borderRadius: "0px",
        borderLeft: "none", // Remove right side border
        borderTop: "none", // Remove top border
        borderBottom: "none", // Remove bottom border
    };
    const selectStyleBorder = {
        border: "1px solid rgba(0, 0, 0, 0.1)", // Remove the border
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    const selectStyle = {
        border: "none", // Remove the border
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    return (
        <div
            className="row"
            style={{
                display: "flex",
                alignItems: "end",
                width: "100%",
                margin: "10px 0px",
                justifyContent: "space-between",
            }}
        >
            <div style={{ fontFamily: "Poppins" }}>
                <strong>{`Showing ${count} of ${total} entries`}</strong>
            </div>

            <div className="d-flex btn-group p-1" style={selectStyleBorder}>
                <select
                    style={selectStyleLeftBorder}
                    className=" d-flex justify-content-end "
                    aria-label="offset"
                    onChange={(e) => {
                        callback2(e.target.value);
                    }}
                >
                    {offsetArr.map((offset) => (
                        <option value={offset} className="d-flex justify-content-end">
                            {offset}
                        </option>
                    ))}
                </select>
                {page - 2 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {"<<"}
                    </Button>
                ) : null}

                {page - 1 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white underline-text"
                    >
                        {" "}
                        {(page - 1).toString()}
                    </Button>
                ) : null}

                <Button className="bg-white text-primary " style={selectStyle}>
                    {" "}
                    {page.toString()}
                </Button>

                {/* Next And Previous Button Code */}
                {page + 1 <= limit ? (
                    <Button
                        onClick={() => {
                            callback(page + 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {">>"}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

export default MasterBusinessReport;